import { OrganizationKeyName } from "../../../model/Organization";

export const GET_PRODUCT_FAIL = "SHOP:GET_PRODUCT_FAIL";

export const getProductFailAction = (
  organization: OrganizationKeyName,
  id: string
) => ({
  type: GET_PRODUCT_FAIL as typeof GET_PRODUCT_FAIL,
  organization,
  id,
});

export type GetProductFailAction = ReturnType<typeof getProductFailAction>;
